// Hook for restrict enter other than number & length should be 9 or 10.
export const useMobileInput = () => {
  const handleInputChange = (
    input: string,
    setFormikValue: (field: string, value: string) => void,
    fieldLabel: string,
    countryCode: string,
  ) => {
    // Allow only numbers
    const numericValue = input.replace(/[^0-9]/g, "");

    // Set max length based on country code
    const maxLength = countryCode === "+66" ? 9 : 10;

    // Trim input to max length and update Formik directly
    const trimmedValue = numericValue.slice(0, maxLength);
    setFormikValue(fieldLabel, trimmedValue);
  };

  return { handleInputChange };
};
